import React, { useMemo } from "react";
import { ICarBrand } from "../../../interfaces";
import CustomSelect from "../CustomSelect/CustomSelect";

interface CarBrandSelectProps {
  carBrands: ICarBrand[];
  selectedCarBrand: string;
  onChange: (value: string) => void;
}

const CarBrandSelect: React.FC<CarBrandSelectProps> = ({
  carBrands,
  selectedCarBrand,
  onChange,
}) => {
  const options = useMemo(
    () => carBrands.map((b) => ({ value: b.id, label: b.name })),
    [carBrands]
  );
  return (
    <CustomSelect
      id="car_brand"
      label="Марка"
      placeholder="Выберите марку авто"
      options={options}
      value={selectedCarBrand}
      onChange={onChange}
    />
  );
};

export default CarBrandSelect;
